import React, { useState } from "react";
import { Row, Col, Form,FormGroup, Input, Pagination, PaginationItem, PaginationLink } from "reactstrap";

import "react-datepicker/dist/react-datepicker.css";

import { useTrackingCategories } from "../../Xero/Reports/tracking-categories/useTrackingCategories";
import Select from "react-select";

import { Trans } from "react-i18next";
import { Page } from "components/common";
import ShiftTable from "./ShiftTable";


const ShiftAssignment = ({ t, portalEmployee, ...props }) => {

    const [changer, setChanger] = useState({ 'dateoffset': 0, 'department': '', 'date': 'daily', 'searchq': '', 'pickedDate': new Date() })

    const { data: trackingCategories } = useTrackingCategories();

    const getOptions = () => {
        return trackingCategories[0] ? trackingCategories[0].Options.map(el => ({ value: el.Name, label: el.Name })) : []
    }
    const getLabel = () => {
        return trackingCategories[0] ? trackingCategories[0].Name : ""
    }

    
    // useEffect(() => {
    //     setChanger({
    //         ...changer, pickedDate: new Date((window.localStorage.getItem('pickedDate')) || ''),
    //         dateoffset: (parseInt(window.localStorage.getItem('dateoffset')) || 0)
    //     });

    // }, [reload])

    // useEffect(() => {
    //     window.localStorage.setItem('pickedDate', changer.pickedDate);
    //     window.localStorage.setItem('dateoffset', changer.dateoffset);
    // }, [changer.pickedDate, changer.dateoffset]);

    return (
        <Page title={t('Shifts Assignment')} showTitle={false}>
            <h4 className="mb-3"><Trans>Shift Assignment</Trans>:</h4>
            <Form className="form mt-2">
                <Row className="pr-3">
                    <Col className="col-xs-5 col-md-5 pr-0">
                        <FormGroup>
                            <Input
                                type="text"
                                name="serach"
                                id="search"
                                style={{
                                    fontFamily: "FontAwesome, Arial",
                                    fontStyle: "normal",
                                }}
                                placeholder={t("Search by employee name")}
                                value={changer.searchq}
                                onChange={(e) => { setChanger({ ...changer, searchq: e.target.value || "" }) }}
                            />
                        </FormGroup>
                    </Col>
                    <Col className="col pr-0">
                        <FormGroup>
                            <Select placeholder={`Filter By ${getLabel()}`} options={trackingCategories.length > 0 ? getOptions() : []} value={changer.department} onChange={(e) => setChanger({ ...changer, department: e ? e.value : "" })} />
                        </FormGroup>
                    </Col>
                    <Col className="col pr-0">
                        <FormGroup>
                            <Input type="date" name="shift-date-filter" id="shift-date-filter" placeholder={t("Select Date")} value={changer.pickedDate || ""}
                                onChange={(e) => setChanger({ ...changer, pickedDate: e.target.value || '', filter_by_date: e.target.value || '', dateoffset: 0 })}>
                            </Input>
                            {/* <DatePicker  /> */}

                        </FormGroup>
                    </Col>
                    {/* <Col className="col">
                                        <FormGroup>
                                            <Select name="date" placeholder={t("Select")} clearable={false} disabled={false} searchable={false} defaultValue='daily' options={[{label:`${t('Daily')}`, value:'daily'}, {label:`${t('Monthly')}`, value:'monthly'}]} value={changer.date} onChange={(e) => setChanger({...changer, date:e ? e.value:""})}/>
                                        </FormGroup>
                                    </Col> */}
                </Row>
            </Form>
            {/* Modal Here */}

            <div>
            <ShiftTable portalEmployee={portalEmployee} changer={changer} setChanger={setChanger} t={t} />
            </div>

            <Row>
                <Col>
                    <Pagination
                        aria-label="Page navigation example"
                        className="float-left"
                    >
                        <PaginationItem disabled>
                            <PaginationLink first href="#" />
                        </PaginationItem>
                        <PaginationItem disabled>
                            <PaginationLink href="#" previous />
                        </PaginationItem>
                        <PaginationItem active>
                            <PaginationLink href="#">1</PaginationLink>
                        </PaginationItem>
                        <PaginationItem>
                            <PaginationLink href="#" next />
                        </PaginationItem>
                        <PaginationItem>
                            <PaginationLink href="#" last />
                        </PaginationItem>
                    </Pagination>
                </Col>
            </Row>
        </Page>
    );
};


export default ShiftAssignment;
